import React from "react";

// Public support / contact page for the Doserne Academy app (web + iOS + Android).
// Used as the "Support URL" in App Store Connect and Google Play Console.
export default function Support() {
  const email = "support@allstillas.no";
  return (
    <div className="min-h-screen bg-white text-slate-800" data-testid="support-page">
      <div className="max-w-3xl mx-auto px-5 py-12">
        <h1 className="text-3xl font-bold text-slate-900">Support</h1>
        <p className="mt-2 text-sm text-slate-500">Doserne Academy</p>

        <section className="mt-8 space-y-3">
          <p>
            Doserne Academy is an internal work tool for employees at Doserne AS. If you need help
            with sign-in, courses, messages or any other question about the app, contact us — we
            reply as quickly as we can on weekdays.
          </p>
        </section>

        <h2 className="mt-8 text-xl font-semibold text-slate-900">Contact us</h2>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li>
            <strong>Email:</strong>{" "}
            <a className="text-blue-600 underline" href={`mailto:${email}`} data-testid="support-email">
              {email}
            </a>
          </li>
          <li><strong>Response time:</strong> usually within 1–2 business days.</li>
        </ul>

        <h2 className="mt-8 text-xl font-semibold text-slate-900">Frequently asked questions</h2>
        <ul className="mt-3 list-disc pl-6 space-y-2">
          <li><strong>Can&apos;t sign in?</strong> Accounts are created by an administrator. Ask your administrator for access, or use &quot;Send code&quot; on the login screen.</li>
          <li><strong>Want to delete your account?</strong> Open &quot;My profile&quot; → &quot;Delete account&quot; in the app, or contact us by email.</li>
          <li><strong>Notifications not arriving?</strong> Enable notifications for the app in your device settings.</li>
        </ul>

        <p className="mt-10 text-sm text-slate-500">
          Privacy? See our <a className="text-blue-600 underline" href="/privacy">privacy policy</a>.
        </p>
      </div>
    </div>
  );
}
